import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Lock, ArrowRight, Loader2 } from "lucide-react";
import { toast } from "sonner";
import Seo from "@/components/Seo";
import { useAuth } from "@/context/AuthContext";

export default function AdminLogin() {
  const { user, login, checking } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!checking && user) navigate("/admin", { replace: true });
  }, [user, checking, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const res = await login(email, password);
    setBusy(false);
    if (res.ok) {
      toast.success("Welcome back!");
      navigate("/admin", { replace: true });
    } else {
      toast.error(res.error);
    }
  };

  return (
    <>
      <Seo title="Staff Login" description="Mom's Best Friend Sitters staff login." />
      <div className="min-h-screen flex items-center justify-center bg-parchment px-4">
        <div className="w-full max-w-md">
          <Link to="/" className="flex flex-col items-center mb-8" data-testid="admin-logo-link">
            <span className="font-serif text-2xl font-semibold text-espresso">Mom's Best Friend</span>
            <span className="text-[10px] uppercase tracking-[0.25em] text-terracotta font-semibold">Staff Portal</span>
          </Link>
          <div className="card-warm p-8 md:p-10">
            <div className="w-12 h-12 rounded-full bg-tinted text-terracotta flex items-center justify-center mb-5"><Lock className="w-5 h-5" /></div>
            <h1 className="font-serif text-2xl text-espresso mb-1">Staff sign in</h1>
            <p className="text-sm text-stoneish mb-6">Manage booking requests, applicants and messages.</p>
            <form onSubmit={submit} className="space-y-4" data-testid="admin-login-form">
              <div>
                <label className="block text-sm font-medium text-espresso mb-1.5">Email</label>
                <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full rounded-xl border border-[#F1E6D0] bg-white px-4 py-3 text-sm focus:outline-none focus:border-terracotta focus:ring-2 focus:ring-terracotta/20" data-testid="admin-email-input" required />
              </div>
              <div>
                <label className="block text-sm font-medium text-espresso mb-1.5">Password</label>
                <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full rounded-xl border border-[#F1E6D0] bg-white px-4 py-3 text-sm focus:outline-none focus:border-terracotta focus:ring-2 focus:ring-terracotta/20" data-testid="admin-password-input" required />
              </div>
              <button type="submit" disabled={busy} className="btn-accent w-full !py-3.5 disabled:opacity-60" data-testid="admin-login-btn">
                {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <>Sign in <ArrowRight className="w-4 h-4" /></>}
              </button>
            </form>
          </div>
          <Link to="/" className="block text-center text-sm text-stoneish mt-6 hover:text-espresso" data-testid="admin-back-home">← Back to website</Link>
        </div>
      </div>
    </>
  );
}
